"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkInboundShippingOption = exports.InboundShipmentStatus = void 0;
var InboundShipmentStatus;
(function (InboundShipmentStatus) {
    InboundShipmentStatus["NEED_PACKAGE_DETAILS"] = "NEED_PACKAGE_DETAILS";
    InboundShipmentStatus["PACKAGES_ADDED"] = "PACKAGES_ADDED";
    InboundShipmentStatus["PACKAGES_FINAL"] = "PACKAGES_FINAL";
    InboundShipmentStatus["READY_FOR_WAREHOUSE"] = "READY_FOR_WAREHOUSE";
    InboundShipmentStatus["IN_TRANSIT"] = "IN_TRANSIT";
    InboundShipmentStatus["ARRIVED"] = "ARRIVED";
    InboundShipmentStatus["CROSS_DOCKING"] = "CROSS_DOCKING";
    InboundShipmentStatus["IN_PREP"] = "IN_PREP";
    InboundShipmentStatus["FORWARDING"] = "FORWARDING";
    InboundShipmentStatus["RECEIVING"] = "RECEIVING";
    InboundShipmentStatus["COMPLETED"] = "COMPLETED";
    InboundShipmentStatus["WAREHOUSE_APPOINTMENT_NEEDED"] = "WAREHOUSE_APPOINTMENT_NEEDED";
})(InboundShipmentStatus = exports.InboundShipmentStatus || (exports.InboundShipmentStatus = {}));
var NetworkInboundShippingOption;
(function (NetworkInboundShippingOption) {
    NetworkInboundShippingOption["SPD"] = "SPD";
    NetworkInboundShippingOption["SPD_EXTERNAL"] = "SPD_EXTERNAL";
    NetworkInboundShippingOption["LTL"] = "LTL";
    NetworkInboundShippingOption["LTL_DELIVERR"] = "LTL_DELIVERR";
    NetworkInboundShippingOption["FTL_DELIVERR"] = "FTL_DELIVERR";
    NetworkInboundShippingOption["LTL_EXTERNAL"] = "LTL_EXTERNAL";
    NetworkInboundShippingOption["FTL_EXTERNAL"] = "FTL_EXTERNAL";
})(NetworkInboundShippingOption = exports.NetworkInboundShippingOption || (exports.NetworkInboundShippingOption = {}));
var CargoType;
(function (CargoType) {
    CargoType["FLC"] = "FLC";
    CargoType["PALLETIZED"] = "PALLETIZED";
})(CargoType || (CargoType = {}));
//# sourceMappingURL=InboundShipment.js.map